module.exports = __webpack_public_path__ + "media/images/icons/outlined/layout-8e9ce2506476549384477c197c580549.svg";